import Counter from "./Counter";
import {Link} from 'react-router-dom'
import {motion} from 'framer-motion'


const EventCard = ({id, time, image, title}) => {


    // let content
    // if (statusCode === 0) {
    //     content = (
    //
    //         <button disabled className='button is-danger mx-auto clrsix pinar noborder wdith100 concertcardbutton '
    //                 >
    //             متاسفانه تمام شد.
    //         </button>
    //     )
    // } else if (statusCode === 2) {
    //     content = (<Counter timestamp={remain}/>)
    // } else {
    //     content = <Link to={`/schedule/${id}`}>
    //
    //         <button
    //
    //             className='button is-align-self-flex-end mx-auto clrone kook has-text-white noborder wdith100 concertcardbutton has-text-weight-bold '
    //             >
    //             خرید بلیط
    //         </button>
    //     </Link>
    // }


    return (
        <>

            <motion.div className='column is-12-mobile is-6-tablet  is-3-desktop' variants={{
                hidden: {scale: 0},
                visible: {scale: 1, opacity: 1}
            }}>
                <div
                    className='card clrtw px-1 mx-auto is-flex is-flex-direction-column is-flex-wrap-wrap is-justify-content-end  is-align-content-center  borderrad1  backgroundadj  '
                    style={{height: '25rem', backgroundImage: `url(${image})`, backgroundSize: 'auto'}}>




                    <p className='kook wdith100  is-size-4 has-text-centered borderrad1 has-text-white  '  style={{backdropFilter: 'blur(10px)' , backgroundColor:'rgb(50 50 50 / 0.6)'}} >
                        {title}


                        <span className='kook has-text-centered is-size-7 is-block py-2 borderrad1' >
                      <i className="bi bi-calendar2-week ml-1"></i>
                            {time}
                  </span>



                    </p>



                    <Link to={`/news/${id}`}>

                        <button

                            className='button is-align-self-flex-end mx-auto clrone kook has-text-white noborder wdith100 borderrad1 concertcardbutton has-text-weight-bold '
                        >
                           جزئیات
                        </button>
                    </Link>


                </div>


            </motion.div>


        </>
    )
}

export default EventCard;